import { Component, HostBinding, HostListener, Input, OnChanges, SimpleChanges, signal } from '@angular/core';

@Component({
  selector: 'lm-drawer-side',
  standalone: false,
  template: '<ng-content></ng-content>',
  styles: [`
    :host {
      display: block;
      overflow: hidden;
      transition: width 400ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
    }
  `]
})
export class LMDrawerSideComponent implements OnChanges {
  protected readonly defaultExpandedWidth = 300;
  protected readonly collapsedWidth = 0;

  /** Viewport widths at or below this are treated as mobile. */
  protected readonly mobileBreakpoint = 600;

  @Input() collapsed = false;

  protected currentWidth = signal(this.defaultExpandedWidth);

  @HostBinding('style.width.px') get hostWidth(): number {
    return this.currentWidth();
  }

  @HostListener('window:resize')
  protected onResize(): void {
    if (!this.collapsed) {
      this.currentWidth.set(this.expandedWidth());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['collapsed']) {
      this.currentWidth.set(this.collapsed ? this.collapsedWidth : this.expandedWidth());
    }
  }

  /**
   * On mobile the drawer fills the viewport width; otherwise it uses the
   * fixed expanded width. visualViewport is preferred when available since it
   * reflects the actual visible area (zoom/on-screen keyboard) on devices.
   */
  protected expandedWidth(): number {
    if (!window) {
      return this.defaultExpandedWidth;
    }

    const visualWidth = window.visualViewport?.width;
    const viewportWidth = visualWidth !== undefined ? visualWidth : window.innerWidth;
    if (viewportWidth <= this.mobileBreakpoint) {
      return viewportWidth;
    }
    return this.defaultExpandedWidth;
  }
}